export const convertToStringId = (id: number, isDST?: boolean): string => {
  if (isDST) {
    return `pff-team-${id}`
  }
  return `pff-player-${id}`
}
